import { render, staticRenderFns } from "./monthly-pay.vue?vue&type=template&id=8ef27bb0"
import script from "./monthly-pay.vue?vue&type=script&lang=js"
export * from "./monthly-pay.vue?vue&type=script&lang=js"
import style0 from "./monthly-pay.vue?vue&type=style&index=0&id=8ef27bb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports